import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import DataTableComponent from './StocksTable';

const Items = () => {

    return (
        <Fragment>
            <Container fluid={true} style={{ paddingTop: '30px' }}>
                {/* {
                    [
                        "active", "inactive"
                    ].map((item, index) => (
                        <Tooltip key={item}
                            anchorId={item}
                            content={item.charAt(0).toUpperCase() + item.slice(1)}
                            place="right"
                            style={
                                {
                                    zIndex: '3',
                                    backgroundColor: 'red',
                                    opacity: '1',
                                    color: 'black',
                                    fontWeight: "600",
                                    fontSize: "1.25rem",
                                    textTransform: "capitalize"
                                }} />
                    ))
                } */}
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DataTableComponent />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );

};

export default Items;